import { Card, CardContent } from "@/components/ui/card";

const CARDS = [
  { key: "tenants_total",    label: "Total",           color: "text-gray-700" },
  { key: "healthy",          label: "Saudável",        color: "text-emerald-600" },
  { key: "warning",          label: "Aviso",           color: "text-amber-600" },
  { key: "degraded",         label: "Degradado",       color: "text-orange-600" },
  { key: "critical",         label: "Crítico",         color: "text-red-600" },
  { key: "unknown",          label: "Desconhecido",    color: "text-gray-500" },
  { key: "qr_required",      label: "QR Pendente",     color: "text-amber-700" },
  { key: "zombie_suspected", label: "Zombie",          color: "text-red-700" },
];

export default function SummaryCards({ summary }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
      {CARDS.map(({ key, label, color }) => (
        <Card key={key}>
          <CardContent className="p-4 text-center">
            <div className={`text-2xl font-bold ${color}`}>
              {summary[key] ?? 0}
            </div>
            <div className="text-xs text-muted-foreground mt-1">{label}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
